module.exports = __webpack_public_path__ + "static/img/bg-2.d6acb57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-2.jpg
// module id = t6KH
// module chunks = 0